import { render, staticRenderFns } from "./TierSelect.vue?vue&type=template&id=b43d9502&scoped=true"
import script from "./TierSelect.vue?vue&type=script&lang=js"
export * from "./TierSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43d9502",
  null
  
)

export default component.exports